import React from "react";
import Node from "../../models/node";
import store from "../../store";
import { setGraph } from "../../store/actions";
import { StartPointType } from "../../types";

export default class MoveSelected {
  static node: Node;
  static dragged: boolean;
  static startPoint: StartPointType;

  static move(
    event: React.MouseEvent<SVGEllipseElement, MouseEvent>,
    node: Node
  ): void {
    MoveSelected.node = node;
    MoveSelected.dragged = true;
    MoveSelected.startPoint = {
      x: event.clientX,
      y: event.clientY,
    };
    document.onmousemove = (e: MouseEvent): void => {
      MoveSelected.onMouseMove(e);
    };
    document.onmouseup = (): void => {
      MoveSelected.onMouseUp();
    };
  }

  static onMouseMove(event: MouseEvent): void {
    if (MoveSelected.dragged) {
      const state = store.getState();
      const graph = state.graph.graph.copy();

      const node = graph.nodes[MoveSelected.node.name];
      const diffX = event.clientX - MoveSelected.startPoint.x;
      const diffY = event.clientY - MoveSelected.startPoint.y;
      node.move(diffX, diffY);

      MoveSelected.startPoint = {
        x: event.clientX,
        y: event.clientY,
      };

      store.dispatch(setGraph(graph));
    }
  }

  static onMouseUp(): void {
    document.onmousemove = null;
    document.onmouseup = null;
    MoveSelected.dragged = false;
  }
}
